// app/javascript/controllers/turnstile_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    sitekey: String,
    size: String,
    theme: String,
  }

  static targets = ["turnstile"]

  connect() {
    this.widgetId = null;
    this.renderTurnstile();
  }

  disconnect() {
    // Clean up the widget when controller is disconnected
    if (this.widgetId !== null && window.turnstile) {
      window.turnstile.remove(this.widgetId);
    }
  }

  renderTurnstile() {
    if (!this.turnstileTarget) return;

    // Wait for Turnstile script to load
    if (typeof window.turnstile === "undefined") {
      // Retry after a short delay (handles async script loading)
      setTimeout(() => this.renderTurnstile(), 100);
      return;
    }

    // Render the Turnstile widget
    this.widgetId = window.turnstile.render(this.turnstileTarget, {
      sitekey: this.sitekeyValue,
      size: this.sizeValue,
      theme: this.themeValue,
      callback: () => {
        this._enableClosestSubmitButton();
      },
      "error-callback": () => {
        console.error("Turnstile failed to load");
      },
      "expired-callback": () => {
        this._disableClosestSubmitButton();
      }
    });
  }

  _enableClosestSubmitButton() {
    if (this.closestSubmitButton) {
      this.closestSubmitButton.removeAttribute("disabled");
    }
  }

  _disableClosestSubmitButton() {
    if (this.closestSubmitButton) {
      this.closestSubmitButton.setAttribute("disabled", "true");
    }
  }

  get closestSubmitButton() {
    return this.element.closest("form")?.querySelector("button[type='submit']");
  }
}
